// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dhDV","col":"styles_col__3eyXb"};